<div
  [class.clickable]="isClickable"
  [class.p-0]="flatProgressBar"
  [class.pill-light]="mode === 'light'"
  class="clickable pill d-flex justify-content-start {{ borderColor }}"
  [style.height.px]="height"
>
  @if(regressionPercentage){
    <div
      [style.width.%]="regressionPercentage"
      [style.background]="'#09013F26'"
      class="regression-progress"
    >
    </div>
  }
  <div
    [style.min-width.%]="filledPercentage"
    [style.background]="showStatusBackground ? backgroundColor : ''"
    class="filled-progress d-flex justify-content-end overflow-hidden"
    [class.filled-progress-light]="mode === 'light'"
    [class.filled-progress-gradient]="isGradient"
    [class.filled-progress-flat]="flatProgressBar"
  >
    @if(regressionPercentage && filledPercentage) {
      <svg-icon name="arrow-backward" style="padding: 0 6px"></svg-icon>
    }@else if(newPercentage) {
      <div class="filled-progress-new" [style.width.%]="newPercentage"></div>
    }
  </div>

  <div class="position-absolute w-100">
    <span class="pill-text" [class.pill-text-light]="mode === 'light'">
      @if (showText) {
        @if (text) {
          {{ text }}
        } @else {
          <span>{{ current }} </span>
          @if (showPercentage) {
            <span>%</span>
          }
          @if (total) {
            &nbsp;
            <span>of {{ total }}</span>
          }
        }
      }
    </span>
  </div>
</div>
